import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteContext = createContext(null);

const FALLBACK = {
  business_name: "Chouhan Taxi Service",
  tagline: "Tour & Travel",
  phone: "099829 03736",
  phone_raw: "+919982903736",
  whatsapp: "919982903736",
  email: "info@chouhantaxiservice.com",
  address: "Mehrangarh Fort Road, Jodhpur, Rajasthan 342024, India",
  logo: "/images/logo.png",
  maps_link: "", maps_embed: "", facebook: "", instagram: "", youtube: "", twitter: "",
};

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);

  useEffect(() => {
    api.get("/settings").then((res) => {
      if (res.data && res.data.business_name) setSettings({ ...FALLBACK, ...res.data });
    }).catch(() => {});
  }, []);

  return <SiteContext.Provider value={settings}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext) || FALLBACK;

export const waLink = (s, text = "Hi, I would like to book a taxi with Chouhan Taxi Service.") =>
  `https://wa.me/${s.whatsapp}?text=${encodeURIComponent(text)}`;
export const telLink = (s) => `tel:${s.phone_raw}`;
